import { PROCESS_APPLICATION_ERROR_MESSAGES } from '#client/constants/messages';

export const ALLOW_LIST_ERROR_MESSAGE = [
  PROCESS_APPLICATION_ERROR_MESSAGES.APPLICATION_NOT_FOUND,
  PROCESS_APPLICATION_ERROR_MESSAGES.APPLICATION_ERROR
];

export const ALLOW_LIST_SUCCESS = [
  PROCESS_APPLICATION_ERROR_MESSAGES.AWAITING_FORMATION,
  PROCESS_APPLICATION_ERROR_MESSAGES.AWAITING_EIN_ORDER_COMPLETION,
  PROCESS_APPLICATION_ERROR_MESSAGES.AWAITING_EIN_ORDER_CREATION,
  PROCESS_APPLICATION_ERROR_MESSAGES.AWAITING_EIN,
  PROCESS_APPLICATION_ERROR_MESSAGES.AWAITING_OPERATING_ADDRESS
];
